module.exports = __webpack_public_path__ + "img/android.8815176c.png";